import { render } from "./HealthCheck.vue?vue&type=template&id=18c59b56&scoped=true"
import script from "./HealthCheck.vue?vue&type=script&lang=js"
export * from "./HealthCheck.vue?vue&type=script&lang=js"

import "./HealthCheck.vue?vue&type=style&index=0&id=18c59b56&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c59b56"]])

export default __exports__